export default __webpack_public_path__ + "static/media/close.a28aea97.svg";